import moment from "moment";

export const formatTime = (date) => {
  return moment(date).format("h:mm A");
};
export const formatDateTime = (date) => {
  return moment(date).format("DD MMMM, hh:mm A");
};
export const formatDate = (date) => {
  return moment(date).format("DD MMMM YYYY");
};
